<select
  class="language-selector"
  [(ngModel)]="selectedLanguage"
  (change)="changeLanguage(selectedLanguage)"
  aria-label="Select Language">
  <option *ngFor="let lang of languages" [value]="lang.code">
    {{ lang.label }}
  </option>
</select>
